$(function() {

	$(".breadcrumbs").find(".mezo .symbol").click(function() {

		var $mezo = $(this).closest(".mezo");

		$mezo.toggleClass("expanded");

		if ($mezo.is(".expanded")) {
			$(document.body).on("click.mobile-breadcrumbs", function() {
				$mezo.find(".symbol").triggerHandler("click");
				return false;
			});

			$mezo.find(".popup").on("click.mobile-breadcrumbs", function(e) {
				e.stopPropagation();
			});

			var leftPos;
			leftPos = $mezo.find(".symbol").position().left - 15;
			$mezo.find(".arrow").css("left", leftPos+"px");

		} else {
			$(document.body).off("click.mobile-breadcrumbs");
			$mezo.find(".popup").off("click.mobile-breadcrumbs");
		}

		return false;

	});

});